if (!customElements.get("sticky-atc")) {
  class StickyATC extends HTMLElement {
    constructor() {
      super();
      this.callback = this.callback.bind(this);
      this.footerCallback = this.footerCallback.bind(this);
      this.buyBoxCallback = this.buyBoxCallback.bind(this);

      // Track visibility states
      this.isMainBtnVisible = false;
      this.isFooterVisible = false;
      this.isBuyBoxVisible = false;
    }

    connectedCallback() {
      this.mainBuyBtn = document.querySelector(".js-main-add-to-cart");
      this.footer = document.querySelector(".shopify-section.shopify-section-group-footer-group");
      this.buyBox = document.querySelector(".product-info-main");

      if (!this.mainBuyBtn || !this.footer) {
        return;
      }

      // Observer for main button visibility
      const mainBtnObserver = new IntersectionObserver(this.callback, { threshold: 0 });
      mainBtnObserver.observe(this.mainBuyBtn);

      // Observer for footer visibility
      const footerObserver = new IntersectionObserver(this.footerCallback, { threshold: 0 });
      footerObserver.observe(this.footer);

      // Desktop only: observe buy-box visibility
      if (window.innerWidth >= 1024 && this.buyBox) {
        const buyBoxObserver = new IntersectionObserver(this.buyBoxCallback, { threshold: 0 });
        buyBoxObserver.observe(this.buyBox);
      }
    }

    callback(entries) {
      entries.forEach((entry) => {
        this.isMainBtnVisible = entry.isIntersecting;
        this.updateVisibility();
      });
    }

    footerCallback(entries) {
      entries.forEach((entry) => {
        this.isFooterVisible = entry.isIntersecting;
        this.updateVisibility();
      });
    }

    buyBoxCallback(entries) {
      entries.forEach((entry) => {
        this.isBuyBoxVisible = entry.isIntersecting;
        this.updateVisibility();
      });
    }

    updateVisibility() {
      // Only show the sticky button when both the main button and footer are NOT visible
      if (!this.isMainBtnVisible && !this.isFooterVisible && !this.isBuyBoxVisible) {
        this.classList.add("is-visible");
      } else {
        this.classList.remove("is-visible");
      }
    }
  }

  customElements.define("sticky-atc", StickyATC);
}
